import { SeparatelyOccupiedUnit as ApiUnit } from '../realty/model/SeparatelyOccupiedUnit';
import { Address as ApiAddress } from '../realty/model/Address';
import { defined, evaluate } from '../utility/Control';
import { Address } from './Address';

const UNIT_LEISURE = 'F';
const UNIT_RESIDENTIAL = 'B';
const UNIT_RESIDENTIAL_NOT_APPROVED = 'I';

export class Unit {
  public unitNumber: string;
  public unitType: string;
  public numberOfRooms: number;
  public numberOfWCs: number;
  public numberOfBathRooms: number;
  public isApproved: boolean;
  public isDwelling: boolean;
  public usableArea: number;
  public address: string;

  public constructor(apiUnit: ApiUnit) {
    this.unitNumber = apiUnit.unitNumber;
    this.numberOfRooms = apiUnit.numberOfRooms || 0;
    this.numberOfWCs = apiUnit.numberOfWCs || 0;
    this.numberOfBathRooms = apiUnit.numberOfBathRooms || 0;
    this.unitType = evaluate(apiUnit, 'unitType.code');
    if (defined(this.unitType)) {
      if (
        this.unitType === UNIT_RESIDENTIAL_NOT_APPROVED ||
        this.unitType === UNIT_RESIDENTIAL ||
        this.unitType === UNIT_LEISURE
      ) {
        this.isDwelling = true;
      }
      this.isApproved = this.unitType !== UNIT_RESIDENTIAL_NOT_APPROVED;
    }
    this.usableArea = apiUnit.usableArea;
    const apiAddress: ApiAddress = evaluate(apiUnit, 'inclusions.address.item');
    if (defined(apiAddress)) {
      this.address = new Address(apiAddress).streetAddress;
    }
  }
}



/** WEBPACK FOOTER **
 ** ./src/model/Unit.ts
 **/